
// import { shuffleArray } from "@/helpers/common";
import { useStateContext } from "../../Contexts/ContextProvider";
import { useEffect, useState } from "react";
import { Table } from "@mantine/core";
import { useDispatch, useSelector } from "react-redux";
import { getClientsList } from "../../store/actions";
import { manageclients_column } from "../../helpers/columns";
import { MantineGrid, MantineGridColumn } from "../../components/mantine/grid";
import { useDisclosure } from "@mantine/hooks";
import { MantineModal } from "../../components/mantine/modal";
import { PlaceholderUi, useCustomMediaQuery } from "../../helpers/common";
import { useDebounce } from "../../utlis/debounceHook";
import MantineButton from "../../components/mantine/button";
import UserForm from "./UserForm";
import MantineContainer from "../../components/mantine/container";
import MantinePagination from "../../components/mantine/pagination";
import ActionMenu from './Components/ActionMenu';
import MantineTextInput from "../../components/mantine/textinput";
import MantineCloseButton from "../../components/mantine/closeButton";
import MantineGroup from "../../components/mantine/group";
import CustomModalHeaderTitle from "../../components/common/customModalHeaderTitle";
import AvatarComponent from "./Components/AvatarComponent";
import StatusComponent from '../../pages/manageclients/Components/StatusComponents';
import TitleComponent from "../../components/common/title";
import ConfirmationPopup from "../../components/common/confirmationPopUp";
import SearchComponent from "../../components/common/search";
import DeleteConfirmation from './delete';
import moment from "moment";


export default function ManageUserProfile() {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState<any>('');
  const [pageSize, setPageSize] = useState<any>(5);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [activepageNumber, setActivePageNumber] = useState<any>(1);
  const [selectedRows, SetSelectedRows] = useState<any>([])
  const [opened, { open, close }] = useDisclosure(false); // modal open close functionality
  const [openedConfirmationPopup, { open: openConfirmationPopup, close: closeConfirmationPopup }] = useDisclosure(false); // modal open close functionality
  const { currentPrimaryColor, currentSecondaryColor, currentTeritorryColor } = useStateContext();
  const { isLargeScreenmin, isSmallScreen } = useCustomMediaQuery();
  const [OpenedDeletePopUp, { open: OpendeletePopUp, close: closeDeletePopUp }] = useDisclosure(false);
  const [getClient, setgetClient] = useState([]);
  const debouncedQuery = useDebounce(searchValue, 500);
  const { getClientredux, Count } = useSelector((state: any) => ({
    getClientredux: state?.getclientData?.clientlist,
    Count: state?.getclientData?.totalCount,
  }));

  useEffect(() => {
    setgetClient(getClientredux)
  }, [(getClientredux)])

  useEffect(() => {
    getList();
  }, [pageNumber, pageSize, debouncedQuery])

  useEffect(() => {
    if (searchValue?.length == 0) {
      const data = {
        "pageNumber": activepageNumber,
        "pageSize": pageSize,
        "sortColumn": "",
        "sortDirection": "",
        "searchKeyword": searchValue
      }
      dispatch(getClientsList(data))
    }
  }, [searchValue])

  const getList = () => {
    const data = {
      "pageNumber": pageNumber,
      "pageSize": pageSize,
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue
    }
    dispatch(getClientsList(data))
  }

  const handleResponseUserForm = (status: any) => {
    if (status === "SUCCESS" || status === "ADD SUCCESS") close(); getList();

    if (opened) {
      close();
    } else {
      open();
    }
  }
  const handleDelete = () => {
    closeDeletePopUp();
    getList();
  }

  // report download concept
  const getclientReport = (reports: any) => {
    const clientData: any = {
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue,
      isExport: true
    };
    if (!reports) {
      clientData.pageNumber = pageNumber;
      clientData.pageSize = pageSize;
    }
    if (reports == true) dispatch(getClientsList(clientData, "export", `${moment(Date()).format('YYYY_MM_DD')}_client_list`))
  }
  // const shuffledAvatarUrls = shuffleArray(avatarUrls);
  // const usersWithAvatar = getUser?.user?.map((user: any, index: number) => ({
  //     ...user,
  //     avatar: shuffledAvatarUrls[index % shuffledAvatarUrls.length]
  // }));
  const handlePageSizeChange = (value: string) => {
    setPageSize(Number(value));
  };

  const handleCloseValue = () => {
    setSearchValue('');
  }
  const rows = getClient?.map((item: any, index: any) => {
    return (
      <Table.Tr key={index}>
        <Table.Td data-label="Client Name">{item.name}</Table.Td>
        <Table.Td data-label="Logo">
          <AvatarComponent
            key={index}
            showName
            item={{ firstName: item.name }}
            src={item.logo} 
            currentPrimaryColor={currentPrimaryColor}
          />
        </Table.Td>
        <Table.Td data-label="Status">
          <StatusComponent item={item} />
        </Table.Td>
        {/* <Table.Td data-label="Created Date">{item.createdAt}</Table.Td> */}
        <Table.Td data-label="Action">
          <ActionMenu
            item={item}
            open={open}
            OpendeletePopUp={OpendeletePopUp}
            SetSelectedRows={SetSelectedRows}
          />
        </Table.Td>
      </Table.Tr>
    );
  });
  
  const classButton = `w-fit text-sm font-thin ${isSmallScreen && 'w-full'}`  // multiple time css call so single line convert
  return (
    <div className="w-full mt-4">
      {/* <MantineTitle order={4} className="m-auto font-semibold text-md text-center">Manage Clients</MantineTitle> */}
      <TitleComponent title="Manage Clients" />
      <MantineContainer fluid={true} className="m-auto bg-white my-6 px-5">
        <MantineGrid className="py-5" grow={true}>
          <MantineGridColumn span={{ base: 12, md: 3, lg: 3 }} >
            <form onSubmit={(event: any) => { event.preventDefault(); setPageNumber(1); getList() }}>
              <MantineTextInput
                placeholder={`Search by Name`}
                onChange={(event: any) => { setSearchValue(event.currentTarget?.value) }}
                value={searchValue}
                rightSection={searchValue?.length >= 1 && <MantineCloseButton onClick={() => handleCloseValue()} />}
                classNames={{ input: `${PlaceholderUi}` }}
              />
            </form>
          </MantineGridColumn>
          <MantineGridColumn span={{ base: 12, md: 3, lg: 3 }}>
            <MantineButton
              name={'Search'}
              color={currentPrimaryColor}
              className={classButton}
              onClick={() => { getList() }}
            />
          </MantineGridColumn>
          <MantineGridColumn span={{ base: 12, md: 6, lg: 6 }}>
            <MantineGroup justify="flex-end">
              <MantineButton
                name={'+ Add New Clients'}
                className={classButton}
                color={currentPrimaryColor}
                onClick={() => { open(); SetSelectedRows([]) }}
              />
              <MantineButton
                name={'Export'}
                color={currentPrimaryColor}
                onClick={() => getclientReport(true)}
                className={classButton}
              />
            </MantineGroup>
          </MantineGridColumn>
        </MantineGrid>
      </MantineContainer>
      <MantineContainer fluid={true} className="m-auto bg-white pt-5 px-5 pb-10">
        <div className={`${rows?.length !== 0 && 'mobile-responsive-scroll'}`}>
          <Table className="bg-global_bg" verticalSpacing="sm">
            <Table.Thead>
              <Table.Tr>
                {manageclients_column?.map((data: any) => {
                  return <Table.Th key={data.id}>{data.name}</Table.Th>;
                })}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody className="relative">
              {rows?.length === 0 ? (
                <Table.Tr>
                  <Table.Td colSpan={manageclients_column.length} className={`${isLargeScreenmin ? 'mt-4 text-center' : 'text-center'}`}>
                    No Data Found
                  </Table.Td>
                </Table.Tr>
              ) : rows}
            </Table.Tbody>
          </Table>
        </div>
        <MantineGroup className={`justify-end pt-5 ${rows?.length == 0 && isLargeScreenmin && 'pb-8'}`}>
          {rows?.length != 0 &&
            <MantinePagination
              total={Math.ceil(Count / pageSize)}
              onChange={(value: any) => { setPageNumber(value); setActivePageNumber(value) }}
              color={currentPrimaryColor}
              withEdges={true}
              valueSelect={pageSize}
              size={"md"}
              className='m-auto pb-4'
              onChangeSelect={handlePageSizeChange}
              value={searchValue?.length != 0 ? pageNumber : activepageNumber}
            />
          }
        </MantineGroup>
        <MantineModal size={"xl"} opened={opened} onClose={close} title={<CustomModalHeaderTitle title={`${selectedRows?.length == 0 ? "Add" : "Edit"} Client`} onClick={close} />}>
          <UserForm clientData={selectedRows} handleResponseUserForm={handleResponseUserForm} modalclose={close} dispatch={dispatch} currentPrimaryColor={currentPrimaryColor} currentSecondaryColor={currentSecondaryColor} />
        </MantineModal>
        {/* <ConfirmationPopup size={"md"} onClose={closeConfirmationPopup} handleConfirm={() => confirmationPopup(selectedRows)} opened={openedConfirmationPopup} ModalBodyMessage={`Are you sure you want to ${!selectedRows?.isActive ? 'Activation' : "De-Activation"} ?`} /> */}
        <MantineModal opened={OpenedDeletePopUp} onClose={closeDeletePopUp} title={<CustomModalHeaderTitle title='Delete' onClick={closeDeletePopUp} />}>
          <DeleteConfirmation clientData={selectedRows} modalclose={closeDeletePopUp} handleDelete={handleDelete} currentPrimaryColor={currentPrimaryColor} currentSecondaryColor={currentSecondaryColor}

          />
        </MantineModal>
      </MantineContainer>
    </div>
  );
}
